module.exports = __webpack_public_path__ + "img/template-demo-2.73bcedf8.jpg";